// extracted by mini-css-extract-plugin
export default {"labelEditor":"QuestionForm_labelEditor__B++pZ","formRichText":"QuestionForm_formRichText__EW7v6","divChoice":"QuestionForm_divChoice__cXA6A"};